import { getBatchUsedByAnchorApi } from 'library-@/apis/lab_api/lab.js';

export async function initializeLabApp(siteRegion: string) {
    try {
        const usedAnchorInLab: Record<string, {
            enabled: boolean;
            anchor: string;
            app_id: string;
            staging: string;
        }> = {};

        if (siteRegion !== 'CN') return usedAnchorInLab;

        const {
            VUE_APP_LAB_IMAGE_MARK_ANCHOR,
            VUE_APP_LAB_PATENT_VIEW_FONT_SIZE_ANCHOR,
            VUE_APP_LAB_DEEP_VIEW_ANCHOR,
            VUE_APP_LAB_DEEP_CLAIM_SWITCH_ANCHOR,
            VUE_APP_LAB_HI_RES_IMAGE_ANCHOR,
        } = process.env;

        const mapping = {
            [VUE_APP_LAB_IMAGE_MARK_ANCHOR]: 'IMAGE_MARK',
            [VUE_APP_LAB_PATENT_VIEW_FONT_SIZE_ANCHOR]: 'FONT_SIZE',
            [VUE_APP_LAB_DEEP_VIEW_ANCHOR]: 'PATENT_DEEP_VIEW',
            [VUE_APP_LAB_HI_RES_IMAGE_ANCHOR]: 'HI_RES_IMAGE',
        };

        const anchors = await getBatchUsedByAnchorApi({
            anchors: [
                VUE_APP_LAB_IMAGE_MARK_ANCHOR,
                VUE_APP_LAB_PATENT_VIEW_FONT_SIZE_ANCHOR,
                VUE_APP_LAB_DEEP_VIEW_ANCHOR,
                VUE_APP_LAB_DEEP_CLAIM_SWITCH_ANCHOR,
                VUE_APP_LAB_HI_RES_IMAGE_ANCHOR,
            ],
        });

        anchors.forEach(item => {
            if (mapping[item.anchor]) {
                usedAnchorInLab[mapping[item.anchor]] = {
                    enabled: Boolean(item.used),
                    anchor: item.anchor,
                    app_id: item.app_id,
                    staging: item.staging,
                };
            }
        });

        return usedAnchorInLab;
    } catch (error) {
        console.warn('getBatchUsedByAnchorApi error', error);
        return {};
    }
}
